module.exports = __webpack_public_path__ + "img/day.27102a5d.png";